'use strict';

const news = {
    el: {
        filters: document.querySelector('.news_filters'),
        filterBtn: document.querySelectorAll('.news_filters .filters_title'),
        loader: document.querySelector('.news_loader'),
        gridCtn: document.querySelector('.news_items'),
        grid: document.querySelector('.news_wrap'),
        itemsSelected: '*',
        nlBlock: document.querySelector('.news_nl'),
        //loadmore: document.querySelector('.loadmore__btn'),
    },
    init: function () {
        if (news.el.filterBtn) {
            // pour ouvrir le selecteur de filtres sur mobile
            news.el.filterBtn.forEach((e) => {
                e.addEventListener('click', function () {
                    news.openFilterList(e);
                });
            });
        }

        let elts = document.querySelectorAll('.news_item[data-link]');
        elts.forEach((item) => {
            item.addEventListener('click', function () {
                window.location = this.dataset.link;
            })
        })
        
        if (news.el.nlBlock) {
            let emailInput = document.querySelector('#nl_email');
            let optim = document.querySelector('.field.field_checkbox.field_terms.field_mandatory');
            emailInput.addEventListener('focus', () => {
                optim.classList.add('visible');
            });
        }

        if (news.el.grid) {
            news.toggleLoader(true);
            /*
            let hidden = news.el.grid.querySelectorAll('.hidden');
            if (hidden) {
                hidden.forEach(e => {
                    e.classList.remove('hidden');
                });
            }
            */

            let initialShow = news.el.grid.dataset.init;
            let itemsLength = news.el.grid.childElementCount;

            let itemsArr = [];
            [...news.el.grid.children].map(item => {
                itemsArr.push(item);
            });


            let hiddenElems = itemsArr.slice(initialShow, itemsLength).map(function (item) {
                return item;
            });

            hiddenElems.forEach(e => {
                e.classList.add('hidden');
            });

            setTimeout(() => {
                news.initGridSize();
            }, 2000);
        }

        /*
        if(news.el.loadmore) {
            news.el.loadmore.addEventListener('click', function() {
                news.loadmore();
            });
        }
        */
    },

    // initialiser la hauteur de la newsroom grid au chargement + au loadmore
    initGridSize: function() {
        let wrap = document.querySelector('.news_wrap');
        if (wrap) {
            if (window.matchMedia("(min-width: 768px)").matches ) {
    
                let items = document.querySelectorAll('.news_item:not(.hidden)').length;
                let size = wrap.dataset.size;
                let lastItemIndex;

                // to check height of all items before calcul issue
                document.querySelectorAll('.news_item:not(.hidden)').forEach(item => {
                    //console.log(item.offsetHeight, item);
                });
    
                // obtenir l'index du dernier item visible de la grid
                
                if (size > items) {
                    lastItemIndex = parseInt(items);
                    //news.el.loadmore.style.display = "none";
                } else {
                    lastItemIndex = parseInt(size);
                }
                

                let lastX = document.querySelectorAll('.news_item')[0];
                let lastX_bottom = lastX.offsetTop + lastX.offsetHeight - wrap.offsetTop;
                let maxHeight = Math.max(lastX_bottom);

                if( lastItemIndex -3 > 0){
                    // pour obtenir la hauteur en px de l'item le plus bas dans la grid
                    let x16 = document.querySelectorAll('.news_item')[lastItemIndex -3];
                    let x16_bottom = x16.offsetTop + x16.offsetHeight - wrap.offsetTop;
                    let x17 = document.querySelectorAll('.news_item')[lastItemIndex -2];
                    let x17_bottom = x17.offsetTop + x17.offsetHeight - wrap.offsetTop;
                    let x18 = document.querySelectorAll('.news_item')[lastItemIndex -1];
                    let x18_bottom = x18.offsetTop + x18.offsetHeight - wrap.offsetTop;
                      // pour obtenir l'item le plus bas dans la grid
                    maxHeight = Math.max(x16_bottom, x17_bottom, x18_bottom);
                }
                
              
    
                // fixer une hauteur à la grid (flexbox columns)
                wrap.style.height = maxHeight + 50 + 'px';
    
            }
            news.toggleLoader(false);
        }
    },

    // loadmore items
    loadmore: function() {
        let wrap = document.querySelector('.news_wrap');
        if (window.matchMedia("(min-width: 768px)").matches ) {
            wrap.style.height = wrap.offsetHeight + 8000 + 'px';
        }
        
        let init = parseInt(wrap.dataset.init);
        let size = parseInt(wrap.dataset.size);
        let hiddenElements = document.querySelectorAll('.news_item.hidden');
        let newList = [];
        for (var i = 0; i < hiddenElements.length; ++i) {
            newList.push(hiddenElements[i]);
            if (i === init -1) {break;}
        }
        newList.forEach((item, i) => {
            item.style.display = "block";
            setTimeout(() => {
                item.classList.remove('hidden');
            }, i * 50);
        });
        
        wrap.dataset.size = size + init;

        setTimeout(function(){
            news.initGridSize();
        }, 1000);

        ga('send', 'event', 'Actualités LoadMore', 'click', 'LoadMore');
    },
    
    // ouverture et fermeture de la liste de filtres
    openFilterList: function (filter) {
        let filters = filter.parentElement;
        if (filters.classList.contains('opened')) {
            filters.classList.remove('opened');
        }
        else {
            filters.classList.add('opened');
        }
    },

    toggleLoader: function(bool) {
        if(bool === true) {
            news.el.loader.style.display = "flex";
            news.el.grid.style.opacity = 0;
        } else {
            news.el.loader.style.display = "none";
            news.el.grid.style.opacity = 1;
        }
    }
};

export default news;



// WEBPACK FOOTER //
// ./src/scripts/components/news.js